import { createAction, createSlice } from "@reduxjs/toolkit";

const confirmValidatorSlice = createSlice({
  name: "confirmValidator",
  initialState: { success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = confirmValidatorSlice;
const confirmValidatorAction = createAction(name);

export {
  confirmValidatorAction,
  actions as confirmValidatorActions,
  reducer as confirmValidatorReducer,
};
